import { render, staticRenderFns } from "./CommercialProductEdit.vue?vue&type=template&id=4db6c64d&scoped=true&"
import script from "./CommercialProductEdit.vue?vue&type=script&lang=js&"
export * from "./CommercialProductEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db6c64d",
  null
  
)

export default component.exports